import { createSelector } from 'reselect';
import { getOfferIdsByFilter } from './getOfferIdsByFilter';

export const getAvailableClassicRewardCount = createSelector(getOfferIdsByFilter, (result) => result.classicRewards?.length || 0);
